(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/sport-floorball/helpers/floorball-helper.js') >= 0) return;  svs.modules.push('/components/themes/sport-floorball/helpers/floorball-helper.js'); 
(function(svs) {
  'use strict';

  var isServerSide = typeof exports === 'object';
  if (!isServerSide) {
    registerHelpers(Handlebars);
  }

  function registerHelpers(hbs) {
    function abbreviatePlayerName(firstName, lastName, name) {
      return new hbs.SafeString(
        svs.utils.format.abbreviatePlayerName(firstName, lastName, name)
      );
    }

    function lineupLine(list, home, iterations) {
      var ret = '';
      var rows = iterations ? iterations : 5;

      if (!_.isArray(list)) {
        return ret;
      }

      for (var j = 0; j < rows; j++) {
        if (list[j]) {
          ret +=
            '<div class="lineup-player' +
            (home ? ' lineup-players-home' : '') +
            '"><div class="f-inverted"><span class="bold">' +
            list[j].shirtNumber +
            '.</span> ' +
            list[j].name +
            ' (' +
            list[j].position +
            ')</div>';
          ret += '</div>';
        } else {
          ret +=
            '<div class="f-inverted lineup-player' +
            (home ? ' lineup-players-home' : '') +
            '">&nbsp;</div>';
        }
      }
      return ret;
    }

    hbs.registerHelper('renderMutualsFloorball', function(mutuals) {
      var ret = '',
        home = mutuals.homeWins,
        away = mutuals.awayWins,
        total = home + away;
      if (total === 0) {
        return '';
      }

      ret += '<ul class="three-bars span12 spread-container">';
      ret +=
        '<li style="width:' +
        home / total * 100 +
        '%" class="spread three-bar three-bar-dominant">' +
        home +
        '</li>';
      ret +=
        '<li style="width:' +
        away / total * 100 +
        '%" class="spread three-bar">' +
        away +
        '</li>';
      ret += '</ul>';

      return new hbs.SafeString(ret);
    });

    hbs.registerHelper('abbreviatePlayerName', abbreviatePlayerName);

    hbs.registerHelper('floorballPlayerGoalAssists', function(assistList) {
      var ret = '';
      if (_.isArray(assistList)) {
        var i;
        for (i = 0; i < assistList.length; i++) {
          if (_.isEmpty(assistList[i].firstName)) {
            assistList.splice(i, 1);
          }
        }
        var maxLength = assistList.length > 2 ? 2 : assistList.length;

        for (i = 0; i < maxLength; i++) {
          if (
            assistList[i].firstName && assistList[i].lastName ||
            assistList[i].name
          ) {
            ret +=
              '<span>' +
              svs.utils.format.abbreviatePlayerName(
                assistList[i].firstName,
                assistList[i].lastName,
                assistList[i].name
              );
            ret += i < maxLength - 1 ? ', </span>' : '</span>';
          }
        }
      }
      return new hbs.SafeString(ret);
    });

    hbs.registerHelper('floorballLineup', function(homeMatrix, awayMatrix) {
      var ret = '';
      var titles = [
        'Målvakter',
        '1:a femman',
        '2:a femman',
        '3:e femman',
        '4:e femman',
        'Extra spelare',
        'Extra spelare'
      ];

      var iterations =
        homeMatrix.length > awayMatrix.length
          ? homeMatrix.length
          : awayMatrix.length;

      for (var i = 0; i < iterations; i++) {
        ret += '<div class="left span12 start-five">';
        ret +=
          '<h2 class="statistics-header lineup-header">' + titles[i] + '</h2>';

        if (i === 0) {
          var goalies =
            homeMatrix[i].length > awayMatrix[i].length
              ? homeMatrix[i].length
              : awayMatrix[i].length;

          ret += '<div class="left span6">';
          ret += lineupLine(homeMatrix[i], true, goalies);
          ret += '</div><div class="left span6">';
          ret += lineupLine(awayMatrix[i], false, goalies);
          ret += '</div>';
        } else {
          ret += '<div class="left span6">';
          ret += lineupLine(homeMatrix[i], true);
          ret += '</div><div class="left span6">';
          ret += lineupLine(awayMatrix[i], false);
          ret += '</div>';
        }
        ret += '</div>';
      }

      return new hbs.SafeString(ret);
    });

    hbs.registerHelper('showSuddenDeathWins', function(
      tableRows,
      currentRow,
      options
    ) {
      if (_.isArray(tableRows)) {
        if (currentRow) {
          return options.fn(this);
        }
        for (var i = 0; i < tableRows.length; i++) {
          if (_.has(tableRows[i].rowData, 'suddenDeathWin')) {
            return options.fn(this);
          }
        }
      }
      return options.inverse(this);
    });
  }
})(svs);

 })(window);